/**************************************************
 * Nombre:       CatalogoLista
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import ListaOfertas from "./ListaOfertas";
import estetica from '../../../../Recursos/Escuelas/estetica.png'
import sistemas from '../../../../Recursos/Escuelas/sistemas.png'
import salud from '../../../../Recursos/Escuelas/salud.png'
import negocio from '../../../../Recursos/Escuelas/negocio.png'
import arte from '../../../../Recursos/Escuelas/arte.png'
import deporte from '../../../../Recursos/Escuelas/deporte.png'
import infantil from '../../../../Recursos/Escuelas/infantil.png'
import juridicas from '../../../../Recursos/Escuelas/juridicas.png'
import veterianaria from '../../../../Recursos/Escuelas/veterianaria.png'
import aduanas from '../../../../Recursos/Escuelas/aduanas.png'
import turismo from '../../../../Recursos/Escuelas/turismo.png'
import electricos from '../../../../Recursos/Escuelas/eletricos.png'
import comida from '../../../../Recursos/Escuelas/comida.png'
import {OFERTAACADEMICA} from "../../../../Constantes";


const CatalogoLista = () => {


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 0}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8, px: 6}}>
                    <ListaOfertas items={OFERTAACADEMICA}/>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default CatalogoLista

